import { createSlice } from "@reduxjs/toolkit";

interface UserState {
  canInitializeUser: boolean;
}

const USER_DEFAULT_STATE: UserState = {
  canInitializeUser: true,
};

export const userSlice = createSlice({
  name: "user",
  initialState: USER_DEFAULT_STATE,
  reducers: {},
});
